export const MapSearchHelper = function ({showNearbyProjectsHelper, performNewSearchOnMapCenter, isLoading}) {
    const displayNearbyProjectsTooltip = !isLoading && showNearbyProjectsHelper;
    return (
        <button tabIndex="0" role="button" aria-label="More projects nearby" className={ 'zoom-out-notification ' + (displayNearbyProjectsTooltip ? 'enabled' : 'disabled')} onClick={() => performNewSearchOnMapCenter()} id='see-nearest-projects' type='button'>
            <div className="text">
                Show more schools outside this area
            </div>
        </button>
    );
};
